<template>
    <form @submit.prevent="submit">
        <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-white">
                Nome da Feature
            </label>
            <input
                v-model="form.name"
                type="text"
                class="w-full px-3 py-2 text-black bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Digite o nome da feature flag"
                required
            />
        </div>

        <div class="mb-4">
            <form-toggle
                v-model="form.is_active"
                label="Feature Ativa"
            />
        </div>

        <div class="flex justify-end space-x-2">
            <submit-button
                :loading="loading"
                class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
            >
                {{ featureFlag ? 'Atualizar' : 'Salvar' }}
            </submit-button>
        </div>
    </form>
</template>

<script>
import { useToast } from "vue-toastification";
import SubmitButton from "../forms/SubmitButton.vue";
import FormToggle from "../forms/FormToggle.vue";

export default {
    props: { featureFlag: { type: Object, default: null } },
    components: { SubmitButton, FormToggle },
    emits: ["fetch"],
    data() {
        return {
            show: false,
            loading: false,
            form: {
                name: "",
                is_active: false,
            },
        };
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    mounted() {
        if (this.featureFlag) {
            this.form = {
                name: this.featureFlag.name,
                is_active: this.featureFlag.is_active,
            };
        }
    },

    methods: {
        async submit() {
            if (!this.form.name.trim()) {
                this.toast.error("Preencha o nome da feature flag.");
                return;
            }

            this.loading = true;

            let promise = this.featureFlag
                ? axios.put(`/api/feature-flags/${this.featureFlag.id}`, this.form)
                : axios.post("/api/feature-flags", this.form);

            promise
                .then((response) => {
                    this.loading = false;
                    this.$emit("fetch");
                    this.toast.success("Feature flag salva com sucesso!");
                })
                .catch((error) => {
                    this.loading = false;
                    const message = error.response?.data?.message || "Não foi possível concluir essa solicitação.";
                    this.toast.error(message);
                });
        },
    },
};
</script>